<template>

  <div class="vflex">

    <div class="vflex-row-0 vflex-header p-3">
      <div class="page-title">
        <div class="title">
          <h4>{{ $t('Emails') }}</h4>
        </div>
      </div>
    </div>

    <div class="vflex-row-1">
      <div class="hflex">
        <div class="hflex-col-1 pt-3">
          <EmailList />
        </div>
        <div class="hflex-col-1">
          <EmailContent />
        </div>
      </div>
    </div>

  </div>

</template>

<script>
import EmailList from './EmailList'
import EmailContent from './EmailContent'

export default {
  name: 'Email',
  components: {
    EmailList,
    EmailContent
  },
  data () {
    return {
    }
  },
  computed: {
  },
  metaInfo () {
    return {
      title: this.$t('Emails')
    }
  },
  created () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Email/Email.vue